import getAccountSourceListStore from '../store/accountSourceListStore';

export default function getMailAccountSources() {
    return getAccountSourceListStore().sources.filter(
        accountSource => accountSource.characteristics.supportsMail
    );
}
